/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addWidget} from '../api'

export const useMutationAddWidget = createReactQueryMutationHook('addWidget', addWidget)
